import * as actionTypes from './actionTypes';

export const updateGridView = ({
  activeViewId,
  columnState,
  dispatch,
  filterState,
  gridId,
  sortState
}) => {
  return dispatch({
    type: actionTypes.UPDATE_GRID_VIEW,
    payload: { gridId, activeViewId, columnState, sortState, filterState }
  });
};

export const updateSavedView = ({ activeViewId, dispatch, gridId }) => {
  return dispatch({ type: actionTypes.UPDATE_SAVED_VIEW, payload: { gridId, activeViewId } });
};

export const clearGrids = (dispatch) => {
  return dispatch && dispatch({ type: actionTypes.CLEAR_GRIDS });
};

export const test = '';
